import { IOSROUTE, PCCOMEINURL, THIRDPARTY, THIRDPARTYURL } from '@/utils/const';
import {
	getAppUserInfo,
	getCookie,
	getOpenid,
	getUrlParam,
	getUserInfo,
	isApp,
	isHuatzq,
	isJdjr,
	isPc,
	isWx,
	isWxMiniProgram,
	isWxWork,
	removeOpenid,
	removeUrlParam,
	removeUserInfo,
	saveOpenid,
	saveUserInfo
} from '@/utils/api';

import { BASEURL } from '../fetch/host';
import NativeApp from '@/utils/app';
import Vue from 'vue';
import VueRouter from 'vue-router';
import bridge from '../thirdparty/scripts/bridge';
import store from '../store';
import { translate } from '@/assets/js/i18n';

// 加载第三方合作组件

/**
 * *****路由定义规则参考****
 * name    |    description     |    example
 * ------------------------------------------------
 * r_v      |    router-view
 * index    |   目录主页面：      |    user-我主页
 * home     |   业务主页面        |    user-个人信息
 * list    |   内容列表。        |    nlive-路演列表
 * detail  |   内容详情          |    nlive-路演详情
 * edit    |   编辑             |    setting-意见反馈
 */
// router-view 视图渲染窗口

Vue.use(bridge);

Vue.use(VueRouter);
const vue = new Vue();

// clear storage
const Clear = () => import(/* webpackChunkName: "index" */ '@/view/clear');

// pdf locked

// 微信授权
const Author = () => import(/* webpackChunkName: "index" */ '@/view/author');

// 搜索
const Search = () => import(/* webpackChunkName: "index" */ '@/view/search');

// 404 空白页
const Blank = () => import(/* webpackChunkName: "index" */ '@/view/404');

const AppDownload = () => import(/* webpackChunkName: "index" */ '@/view/app-download');

const AppUpdateTips = () => import(/* webpackChunkName: "index" */ '@/view/app-update-tips');

// 手签
const HandSign = () => import(/* webpackChunkName: "index" */ '@/view/signature');
// 承诺书
const MeetingPromise = () => import(/* webpackChunkName: "index" */ '@/view/promise');

const Iframe = () => import(/* webpackChunkName: "index" */ '@/view/iframe');

const RouterView = () => import(/* webpackChunkName: "index" */ '@/view/router_view');
const Layout = () => import(/* webpackChunkName: "index" */ '@/view/layout');

const UserEnterprise = () => import(/* webpackChunkName: "user" */ '@/view/user/enterprise');
// 登录相关
const Login = () => import(/* webpackChunkName: "login" */ '@/view/login/login');

const Register = () => import(/* webpackChunkName: "account_register" */ '@/view/login/account_register');
const ForgetPassword = () => import(/* webpackChunkName: "forget_password" */ '@/view/login/forget-password');
const LoginFailure = () => import(/* webpackChunkName: "login" */ '@/view/login/failure');
const BindPhone = () => import(/* webpackChunkName: "login" */ '@/view/login/bind_phone');
const BindPhoneRegister = () =>
	import(/* webpackChunkName: "bind_phone_register" */ '@/view/login/bind_phone_register');
const ChangeBindPhone = () => import(/* webpackChunkName: "login" */ '@/view/login/change_bind_phone');
const BindEmail = () => import(/* webpackChunkName: "login" */ '@/view/login/bind_email');
const ChangeBindEmail = () => import(/* webpackChunkName: "login" */ '@/view/login/change_bind_email');
const AccountCancel = () => import(/* webpackChunkName: "login" */ '@/view/login/account_cancel');
const AccountCancelCode = () => import(/* webpackChunkName: "login" */ '@/view/login/account_cancel_code');
const AccountCancelProtocol = () => import(/* webpackChunkName: "login" */ '@/view/login/account_cancel_protocol');
const AccountCancelFail = () => import(/* webpackChunkName: "login" */ '@/view/login/account_cancel_fail');

const BizAttendMeetingSearch = () =>
	import(/* webpackChunkName: "biz_attend_meeting" */ '@/view/biz/attend-meeting/search');

// irm活动页面迁移
// 路演会议、调研活动报名页

const ApplyInfo = () => import(/* webpackChunkName: "ApplyInfo" */ '@/view/attend-meeting/applyInfo');
const signSuccess = () => import(/* webpackChunkName: "signSuccess" */ '@/view/attend-meeting/signSuccess');
const ApplyResult = () => import(/* webpackChunkName: "ApplyResult" */ '@/view/attend-meeting/apply-result');
const TransferPage = () => import(/* webpackChunkName: "TransferPage" */ '@/view/attend-meeting/transfer-page');
const PdfPreview = () => import(/* webpackChunkName: "PdfPreview" */ '@/view/attend-meeting/preview');
const CheckPage = () => import(/* webpackChunkName: "CheckPage" */ '@/view/attend-meeting/check-page');
const ApprovalPage = () => import(/* webpackChunkName: "ApprovalPage" */ '@/view/attend-meeting/approval');
const PreQuestionPage = () =>
	import(/* webpackChunkName: "PreQuestionPage" */ '@/view/attend-meeting/pre-question-page');
const marketingPage = () =>
	import(/* webpackChunkName: "marketingPage" */ '@/view/attend-meeting/marketing-page/index.vue');
const Ticked = () => import(/* webpackChunkName: "Ticked" */ '@/view/attend-meeting/ticked');
const MeetingEcards = () => import(/* webpackChunkName: "MeetingEcards" */ '@/view/attend-meeting/eCard');

// 年终总结
const SummaryReport = () => import(/* webpackChunkName: "SummaryReport" */ '@/view/summary/report');
// 电子签
const VisaTaskList = () => import(/* webpackChunkName: "VisaTaskList" */ '@/view/e-visa/task-list');
const VisaTaskVote = () => import(/* webpackChunkName: "VisaTaskVote" */ '@/view/e-visa/task-vote');
// 批量签署
const EVisaBatchSign = () => import(/* webpackChunkName: "EVisaBatchSign" */ '@/view/e-visa/e-batch-sign');
const EVisaChooseSeal = () => import(/* webpackChunkName: "EVisaChooseSeal" */ '@/view/e-visa/e-choose-seal');
const EVisaPreviewPdf = () => import(/* webpackChunkName: "EVisaPreviewPdf" */ '@/view/e-visa/e-preview-pdf');
const EVisaLogin = () => import(/* webpackChunkName: "EVisaLogin" */ '@/view/e-visa/e-visa-login');
const EVisaSignSuccess = () => import(/* webpackChunkName: "EVisaSignSuccess" */ '@/view/e-visa/e-sign-success');
const EVisaIframe = () => import(/* webpackChunkName: "EVisaIframe" */ '@/view/e-visa/e-task-iframe');

// 会议监控
const ConferenceMonitor = () => import(/* webpackChunkName: "ConferenceMonitor" */ '@/view/conference/monitor');

// 调研日历邀约
const Appointment = () => import(/* webpackChunkName: "Appointment" */ '@/view/investor_appointment/appointment.vue');
const Entourage = () => import(/* webpackChunkName: "Entourage" */ '@/view/investor_appointment/entourage.vue');
const InvestorSuccess = () =>
	import(/* webpackChunkName: "InvestorSuccess" */ '@/view/investor_appointment/success.vue');
const InvestorFail = () => import(/* webpackChunkName: "InvestorFail" */ '@/view/investor_appointment/fail.vue');

import { ENTERPRISE_TOOLS_ROUTERS, ENTERPRISE_SUMMARY_ROUTERS, ENTERPRISE_LEGACY_ROUTES } from '@rebuild/router';
import { ENTERPRISE_REBUILD_ROUTERS } from '@rebuild/router/rebuild';

// 股东管理
const ShareholderPromotion = () => import(/*webpackChunkName: "ShareholderPromotion" */ '@/view/shareholder/promotion');

// 空白页面零食需求
const BlankPage = () => import(/*webpackChunkName: "blank" */ '@/view/blank');

//区号
const AreaCode = () => import(/* webpackChunkName: "AreaCode" */ '@/view/areaCode/index');

const Kingnet = () => import(/*webpackChunkName: "Kingnet" */ '@/view/promotion/kingnet');
const Sansec = () => import(/*webpackChunkName: "Sansec" */ '@/view/promotion/sansec');
const Demo = () => import(/*webpackChunkName: "Demo" */ '@/view/demo');

const Pdfview = () => import(/*webpackChunkName: "Pdfview" */ '@/view/pdfview');

/**
 * 给组件动态注入 [name]
 *
 * @param {String} name 组件自定义名称
 * @param {Component | Promise<Component>} component
 * @return {Component}
 */
function createCustomComponent(name, component) {
	return {
		name,
		data() {
			return { component: null };
		},
		async created() {
			if (component instanceof Promise) {
				try {
					const module = await component;
					this.component = module?.default;
				} catch (error) {
					console.error(`can not resolve component ${name}, error:`, error);
				}

				return;
			}
			this.component = component;
		},
		render(h) {
			return this.component ? h(this.component) : null;
		}
	};
}

const router = new VueRouter({
	history: true,
	mode: 'history',
	saveScrollPosition: true,
	routes: [
		{
			path: '/pdfview',
			name: 'pdfview',
			component: Pdfview,
			meta: {
				title: '',
				skipWxAuth: true
			}
		},
		{
			path: '/demo',
			name: 'demo',
			component: Demo,
			meta: {
				title: 'demo',
				skipWxAuth: true
			}
		},
		{
			path: '/iframe',
			name: 'iframe',
			meta: {
				title: ''
			},
			component: Iframe
		},

		{
			path: '/irm-mobile',
			name: 'mobile',
			component: RouterView,
			redirect: {
				name: 'home'
			},
			children: [
				{
					path: 'promotion',
					name: 'promotion',
					component: RouterView,
					children: [
						{
							path: 'kingnet',
							name: 'kingnet',
							component: Kingnet,
							meta: {
								title: '恺英网络',
								skipWxAuth: true
							}
						},
						{
							path: 'sansec',
							name: 'sansec',
							component: Sansec,
							meta: {
								title: '三未信安',
								skipWxAuth: true
							}
						}
					]
				},
				// TODO
				{
					path: 'iframe',
					name: 'irmIframe',
					component: Iframe,
					meta: {
						title: ''
					}
				},
				// 授权页面
				{
					path: 'author',
					name: 'author',
					component: Author,
					meta: {
						title: '授权',
						title_ht: '华泰证券研究所'
					}
				},

				// clear 清除缓存
				{
					path: 'clear',
					name: 'clear',
					component: Clear,
					meta: {
						title: '清除缓存'
					}
				},

				// 项目首页
				{
					path: 'search',
					name: 'search',
					component: Search,
					meta: {
						title: '搜索'
					}
				},
				// {
				// 	path: 'poster',
				// 	name: 'poster',
				// 	component: PosterList,
				// 	meta: {
				// 		title: "路演"
				// 	},
				// },
				// 项目首页
				{
					path: '404',
					name: '404',
					component: Blank,
					meta: {
						title: ' '
					}
				},
				// app的下载中转页面
				{
					path: 'app-download',
					name: 'app_download',
					component: AppDownload,
					meta: {
						title: '进门'
					}
				},
				{
					path: 'app-update-tips',
					name: 'app-update-tips',
					component: AppUpdateTips,
					meta: {
						title: '温馨提示'
					}
				},

				// 登录相关：登录主页、注册、登录失败
				{
					path: 'login',
					name: 'login',
					component: Login,
					meta: {
						title: '进门登录'
					}
				},

				{
					path: 'register',
					name: 'AccountRegister',
					component: Register,
					meta: {
						title: '进门注册'
					}
				},
				{
					path: 'forget-password',
					name: 'ForgetPassword',
					component: ForgetPassword,
					meta: {
						title: '进门'
					}
				},
				{
					path: 'login-failure',
					name: 'login_failure',
					component: LoginFailure,
					meta: {
						title: '登录失败'
					}
				},
				{
					path: 'bind-phone',
					name: 'bind_phone',
					component: BindPhone,
					meta: {
						title: '绑定手机',
						title_zx: '绑定手机号'
					}
				},
				{
					path: 'sign-phone',
					name: 'bind_phone_register',
					component: BindPhoneRegister,
					meta: {
						title: '绑定手机'
					}
				},
				{
					path: 'change-bind-phone',
					name: 'change_bind_phone',
					component: ChangeBindPhone,
					meta: {
						title: '安全验证'
					}
				},
				{
					path: 'bind-email',
					name: 'bind_email',
					component: BindEmail,
					meta: {
						title: '绑定邮箱',
						title_zx: '绑定邮箱账号'
					}
				},
				{
					path: 'change-bind-email',
					name: 'change_bind_email',
					component: ChangeBindEmail,
					meta: {
						title: '更换邮箱'
					}
				},
				{
					path: 'account_cancel',
					name: 'account_cancel',
					component: AccountCancel,
					meta: {
						title: '账号注销'
					}
				},
				{
					path: 'account_cancel_code',
					name: 'account_cancel_code',
					component: AccountCancelCode,
					meta: {
						title: '',
						meta: '注销验证码'
					}
				},
				{
					path: 'account_cancel_protocol',
					name: 'account_cancel_protocol',
					component: AccountCancelProtocol,
					meta: {
						title: '用户注销协议'
					}
				},

				{
					path: 'account_cancel_fail',
					name: 'account_cancel_fail',
					component: AccountCancelFail,
					meta: {
						title: '账号注销'
					}
				},
				// webirm 扫码登录
				{
					path: 'pc-login',
					name: 'pc_login',
					component: () => import(/* webpackChunkName: "pc-login" */ '@/view/login/pc-login.vue'),
					meta: {
						title: '扫码登录'
					}
				},
				// 会议监控
				{
					path: 'monitor',
					name: 'conference_monitor',
					component: ConferenceMonitor,
					meta: {
						title: '会议监控'
					}
				},

				// 电子签页面
				{
					path: 'visa',
					name: 'e-visa',
					component: Layout,
					children: [
						{
							name: 'visa_task',
							path: 'task',
							component: VisaTaskList,
							meta: {
								title: '签署任务',
								menu: false
							}
						},
						{
							name: 'visa_vote',
							path: 'vote',
							component: VisaTaskVote,
							meta: {
								title: '表决',
								menu: false
							}
						},
						{
							name: 'batch_sign',
							path: 'e-batch-sign',
							component: EVisaBatchSign,
							meta: {
								title: '批量签署',
								menu: false
							}
						},
						{
							name: 'choose_seal',
							path: 'e-choose-seal',
							component: EVisaChooseSeal,
							meta: {
								title: '选择印章',
								menu: false
							}
						},
						{
							name: 'preview-pdf',
							path: 'e-preview-pdf',
							component: EVisaPreviewPdf,
							meta: {
								title: '预览pdf文件',
								menu: false
							}
						},
						{
							name: 'visa-login',
							path: 'visa-login',
							component: EVisaLogin,
							meta: {
								title: '登录校验',
								menu: false
							}
						},
						{
							name: 'sign-success',
							path: 'sign-success',
							component: EVisaSignSuccess,
							meta: {
								title: '签署成功',
								menu: false
							}
						},
						{
							name: 'visa-iframe',
							path: 'visa-iframe',
							component: EVisaIframe,
							meta: {
								title: 'E签宝',
								menu: false
							}
						}
					]
				},
				{
					path: 'user',
					name: 'user_rv',
					component: Layout,
					redirect: {
						name: 'user_home'
					},
					children: [
						// 企业号
						{
							path: 'enterprise',
							name: 'user_enterprise',
							component: UserEnterprise,
							meta: {
								title: '企业号'
							}
						}
					]
				},

				// 业务相关（biz）
				{
					path: 'biz',
					name: 'biz_rv',
					component: Layout,
					children: [
						{
							path: 'attend-meeting',
							name: 'attend_meeting_rv',
							component: Layout,
							redirect: {
								name: 'attend_meeting_home'
							},
							children: [
								{
									path: 'sign',
									name: 'attend_meeting_sign',
									component: HandSign,
									meta: {
										title: '添加签名'
									}
								},
								{
									path: 'promise',
									name: 'attend_meeting_promise',
									component: MeetingPromise,
									meta: {
										title: '承诺书'
									}
								},
								{
									path: 'search',
									name: 'attend_meeting_search',
									component: BizAttendMeetingSearch,
									meta: {
										title: '选择公司'
									}
								}
							]
						}
					]
				},

				// irm活动页面
				{
					path: 'attend-meeting',
					name: 'attend-meeting',
					component: Layout,
					redirect: {
						name: 'attend-meeting-home'
					},
					children: [
						{
							path: 'home',
							name: 'attend-meeting-home',
							component: marketingPage,
							meta: {
								title: '会议介绍',
								module: '沟通管理'
							}
						},
						// 填写报名信息
						{
							path: 'check',
							name: 'attend-meeting-check',
							component: ApplyInfo,
							meta: {
								title: '申请参会',
								module: '沟通管理'
							}
						},
						{
							path: 'zoom',
							name: 'attend-meeting-zoom',
							redirect: {
								name: 'attend-meeting-check'
							},
							meta: {
								title: '申请参会',
								module: '沟通管理'
							}
						},

						{
							path: 'pdf-preview',
							name: 'pdf-preview',
							component: PdfPreview,
							meta: {
								title: '预览pdf',
								module: '沟通管理'
							}
						},
						{
							path: 'transfer-page',
							name: 'transfer-page',
							component: TransferPage,
							meta: {
								title: '线下会议参会中转页',
								module: '沟通管理'
							}
						},
						{
							path: 'self-join',
							name: 'self-join',
							redirect: {
								name: 'attend-meeting-check'
							},
							meta: {
								title: '自助会议申请参会',
								module: '沟通管理'
							}
						},
						// 签到成功
						{
							path: 'sign-success',
							name: 'attend-meeting-success',
							component: signSuccess,
							meta: {
								title: '签到成功',
								module: '沟通管理'
							}
						},
						// 报名结果页
						{
							path: 'apply-result',
							name: 'apply-result',
							component: ApplyResult,
							meta: {
								title: '登记成功',
								module: '沟通管理'
							}
						},

						// 签到页
						{
							path: 'check-page',
							name: 'check-page',
							component: CheckPage,
							meta: {
								title: '活动签到'
							}
						},
						// 审批中页面
						{
							path: 'approval-page',
							name: 'approval-page',
							component: ApprovalPage,
							meta: {
								title: '报名审批'
							}
						},

						// 会议营销页
						{
							path: 'marketing-page',
							name: 'marketing-page',
							component: marketingPage,
							meta: {
								title: '会议介绍'
							}
						},
						{
							path: 'pre-question-page',
							name: 'PreQuestionPage',
							component: PreQuestionPage,
							meta: {
								title: '预提问',
								skipWxAuth: true
							}
						},
						{
							path: 'ticked',
							name: 'attend_meeting_ticked',
							component: Ticked,
							meta: {
								title: '会议签到'
							}
						},
						// 电子名片
						{
							path: 'eCards',
							name: 'attend-meeting-eCards',
							component: MeetingEcards,
							meta: {
								title: '联系我们'
							}
						},

					]
				},
				{
					path: 'summary',
					name: 'summary',
					component: Layout,
					children: [
						{
							path: 'report',
							name: 'summary_report',
							component: SummaryReport,
							meta: {}
						}
					]
				},
				{
					// GraphicSummary
					path: 'graphic',
					name: 'graphic',
					component: Layout,
					children: [
						{
							path: 'summary',
							name: 'graphic_summary',
							component: () => import(/* webpackChunkName: "graphic-summary" */ '@/view/graphic-summary'),
							meta: {}
						}
					]
				},
				{
					path: 'investor',
					name: 'investor',
					component: Layout,
					children: [
						{
							path: 'appointment',
							name: 'investor_appointment',
							component: Appointment
						},
						{
							path: 'entourage',
							name: 'investor_entourage',
							component: Entourage
						},
						{
							path: 'success',
							name: 'investor_success',
							component: InvestorSuccess,
							meta: {
								isEndPage: true
							}
						},
						{
							path: 'fail',
							name: 'investor_fail',
							component: InvestorFail,
							meta: {
								isEndPage: true
							}
						}
					]
				},

				// 投关总结
				...ENTERPRISE_SUMMARY_ROUTERS,
				// 企业号
				...ENTERPRISE_REBUILD_ROUTERS,
				...ENTERPRISE_TOOLS_ROUTERS,
				...ENTERPRISE_LEGACY_ROUTES,

				// 股东管理页面
				{
					path: 'shareholder',
					name: 'shareholder',
					component: Layout,
					children: [
						{
							path: 'promotion',
							name: 'shareholder-promotion',
							component: ShareholderPromotion,
							meta: {
								title: '股东分析'
							}
						}
					]
				},
				{
					path: 'blank',
					name: 'blank',
					component: Layout,
					children: [
						{
							path: '',
							name: '',
							component: BlankPage,
							meta: {
								title: '进门'
							}
						}
					]
				},
				{
					path: 'areaCode',
					name: 'areaCode_index',
					component: AreaCode,
					meta: {
						title: '选择区号'
					}
				}
			]
		}
	]
});

// 路由钩子
router.beforeEach(async (to, from, next) => {
	if (to.fullPath.includes('%20')) {
		console.log('--------- 识别到链接中的空格符号，触发重定向 ---------');
		const newPath = to.fullPath.replace(/%20/g, '');
		// 重定向到新路径，并使用replace防止向历史记录添加新条目
		return next({ path: newPath, replace: true });
	}

	const needReloadRelease = from.query.clearEnv;
	if (!needReloadRelease && from.meta.isEndPage) {
		// 会跟预发布的clearEnv清理重定向产生冲突
		// 如果当前页面是结束页，就阻止跳转
		return next(false);
	}
	//  || to.name == 'graphic_summary'
	if (
		to.name == 'summary_report' ||
		to.name == 'graphic_summary' ||
		to.name == 'enterprise_summary' ||
		to.name == 'attend-meeting-zoom' ||
		to.name == 'areaCode_index' ||
		to.name == 'attend_meeting_search' ||
		to.meta.skipWxAuth
	) {
		//年终总结分享页
		return next();
	}

	let isFrame = to.query.hasOwnProperty('isFrame') && to.query.isFrame;
	let isLocalhost = location.hostname === 'localhost';
	let userInfo = getUserInfo();

	/* 处理PC端打开路演页面 */
	if (isPc && !isFrame && !isWxMiniProgram && !isLocalhost) {
		if (to.name === 'home') {
			return location.replace(PCCOMEINURL);
		}
		// 活动详情页面跳转
		if (to.name === 'marketing-page') {
			const url = to?.fullPath?.replace('/irm-mobile', '/irm-pc');
			return location.replace(PCCOMEINURL + url);
		}
	}

	// 企业号模块, 不走赋值标题的流程
	const enterprise_path = to.path.split('/', 3).join('/');
	const inIRPage = enterprise_path == '/irm-mobile/enterprise';
	if (!inIRPage) {
		document.title = translate(to.meta.title_thirdparty) || translate(to.meta.title) || translate('进门');
	}

	// 第三方合作游客模式不需要走微信授权登录
	if (vue.$bridge.isThirdParty && vue.$bridge.isVistor) {
		return next();
	}

	// 处理第三方合作登录、标准模式
	const bolNormal = Boolean(to.query.channel && to.query.userInfo);
	if (vue.$bridge.isThirdParty && vue.$bridge.comein_channel === 'normal') {
		if (bolNormal) {
			removeUserInfo();
			localStorage.setItem('beforeAuthorUrl', to.fullPath);
			return router.replace({
				name: 'author'
			});
		} else {
			return next();
		}
	}

	/* 处理小程序 用户信息、openid与H5交互
	 * 处理绑定手机号页面，小程序跳转到小程序绑定页面
	 * */
	if (isWxMiniProgram) {
		if (to.query.hasOwnProperty('deleteWxMiniUserInfo')) {
			removeUserInfo();
		}
		if (to.query.hasOwnProperty('deleteWxMiniOpenId')) {
			removeOpenid();
		}
		if (to.query.hasOwnProperty('wxMiniUserInfo')) {
			let wx_userInfo = JSON.parse(decodeURIComponent(to.query.wxMiniUserInfo));
			saveUserInfo(wx_userInfo);
		}
		if (to.query.hasOwnProperty('wxMiniOpenId')) {
			const wx_openid = decodeURIComponent(to.query.wxMiniOpenId);
			saveOpenid(wx_openid);
		}
		next();
		return false;
	}
	// && !userInfo 去掉的原因是,发现在APP中,用户退出登录后，会获取到旧的用户信息
	if (isApp) {
		try {
			userInfo = await getAppUserInfo();
		} catch (error) {
			console.log(error);
		}
	}

	const hasRelease = getCookie('release');
	// 设定 登录、绑定手机号、清除缓存页面不需要授权
	// 预发布 也跳过鉴权
	if (to.meta.noAuthor && hasRelease) {
		return next();
	}

	if (isWx && isWxWork) {
		next();
		return false;
	}

	// 第三方登录、处理京东和微信授权
	if (vue.$bridge.isThirdParty || isJdjr || (isWx && !isWxMiniProgram)) {
		// 处理使用后退返回到授权页，默认返回到首页
		if (to.name === 'author') {
			if (
				(vue.$bridge.isThirdParty && getUserInfo()) ||
				(isJdjr && getUserInfo()) ||
				(isWx && getUserInfo() && getOpenid())
			) {
				const urlSearch = location.search.substr(location.search.indexOf('?beforeUrl=') + 11);
				const beforeUrl = urlSearch && decodeURIComponent(urlSearch);
				if (beforeUrl) {
					router.replace({
						name: 'home'
					});
				}
				return false;
			}
		} else {
			// 第一次进入
			const search = to.fullPath.split('?')[1];
			const urlParamObj = getUrlParam(search ? '?' + search : '');

			const sessionChannelSign = JSON.parse(sessionStorage.getItem(THIRDPARTY)) || {};
			const needAuthor = Boolean(
				Boolean(urlParamObj.comein_channel && urlParamObj.comein_sign) ||
				(Boolean(sessionChannelSign.comein_channel && sessionChannelSign.comein_sign) && !isHuatzq)
			);

			const hasUserInfo = !!getUserInfo();
			if (hasUserInfo) {
				sessionStorage.removeItem('disable-login');
			}

			const step1 = vue.$bridge.isThirdParty && !getUserInfo() && needAuthor;
			const step2 = isJdjr && !getUserInfo();
			const step3 = isWx && !getUserInfo();
			const step4 = vue.$bridge.isThirdParty && Boolean(to.query.comein_channel && to.query.comein_sign);

			if (step1 || step2 || step3) {
				// 免登录兼容
				const disableLoginOnQuery = to.query.hasOwnProperty('autoLogin') && to.query.autoLogin === '1';
				if (disableLoginOnQuery) {
					sessionStorage.setItem('disable-login', disableLoginOnQuery ? '1' : '0');
				}
				const skipLogin = sessionStorage.getItem('disable-login') === '1';
				if (skipLogin && step3) {
					return next();
				}
				if (isInIframe()) {
					return next();
				}
				removeUserInfo();
				// 首先存储 当前url
				// 单独处理恒生详情页面,被嵌入页面处理登录
				localStorage.setItem('beforeAuthorUrl', to.fullPath);
				window.location.href = '/mobile/author?beforeUrl=' + encodeURIComponent(to.fullPath);
				return false;
			} else if (step4) {
				// 处理 第三方 已经登录
				let next_path = removeUrlParam(to.fullPath, ['comein_channel', 'comein_sign']);
				router.replace(next_path);
				return false;
			}
		}
	}
	// 进入页面
	next();
});

router.beforeResolve((to, from, next) => {
	handleKeepAlive(to);
	// 进入页面
	next();
});

function isInIframe() {
	return window !== window.top;
}

function handleKeepAlive(to) {
	if (to.matched && to.matched.length > 2) {
		for (let i = 0; i < to.matched.length; i++) {
			const element = to.matched[i];
			if (element.components.default.name === 'Layout' || element.components.default.name === 'layout') {
				to.matched.splice(i, 1);
				handleKeepAlive(to);
			}
		}
	}
}
// 监听路演进入之后
router.afterEach((to, from, next) => {
	// 当前环境下没有装进门App/则跳到下载引导页
	if (location.origin === IOSROUTE) {
		return location.replace(THIRDPARTYURL + '/mobile/app-download?url=' + location.pathname + location.search);
	}

	store && store.dispatch('fetchWxConfig', location.origin + to.fullPath);

	if (isApp) {
		// 防盗录、截屏
		// const noScreenShotName = ['roadshow_home', 'roadshow_record', 'research_report_detail', 'iframe'];
		// 1表示允许，0表示不允许
		// const noScreenShotState = Number(!noScreenShotName.includes(to.name));
		NativeApp.setScreenCaptureState({
			state: 1
		});
	}

	// if(to.name === "roadshow_home" || to.name === "roadshow_record" || to.name === "roadshow_room"){
	// 	store.dispatch('fetchWxConfig');
	// }

	if (to.query.isComeInMP) {
		sessionStorage.setItem('isComeInMP', to.query.isComeInMP);
	}

	/* 兼容APP内 苹果安全区域 */
	if (isApp) {
		if (to.name === 'enrollment_appoint') {
			$('#app').removeClass('safe-area');
		} else {
			if (!$('#app').hasClass('safe-area')) {
				$('#app').addClass('safe-area');
			}
		}
	}

	/* 兼容第三方嵌入页面的高度问题 */
	if (
		to.name === 'stock_tabs_character' ||
		to.name === 'stock_tabs_article' ||
		to.name === 'stock_tabs_interaction' ||
		to.name === 'activity_sem_home'
	) {
		$('#app').addClass('auto-height').removeClass('safe-area');
		$('.router-view').addClass('auto-height');
	} else {
		let selectApp = $('#app');
		let selectRouterView = $('.router-view');
		selectApp.hasClass('auto-height') && selectApp.removeClass('auto-height').addClass('safe-area');
		selectRouterView.hasClass('auto-height') && selectRouterView.removeClass('auto-height');
	}
});
export default router;
